export const labelKeys = {
  list: () => ['LABELS'],
  byKey: (key: string | undefined) => ['LABEL', key],
  allLabels: (locale: string) => ['LABELS_ALL', locale],
};
